export const OPEN_MODAL_CNPJ = 'lead/OPEN_MODAL_CNPJ'
export const CLOSE_MODAL_CNPJ = 'lead/CLOSE_MODAL_CNPJ'

export const OPEN_MODAL_LEAD = 'lead/OPEN_MODAL_LEAD'
export const CLOSE_MODAL_LEAD = 'lead/CLOSE_MODAL_LEAD'

export const OPEN_MODAL_PRODUCT_EXISTING = 'lead/OPEN_MODAL_PRODUCT_EXISTING'
export const CLOSE_MODAL_PRODUCT_EXISTING = 'lead/CLOSE_MODAL_PRODUCT_EXISTING'

export const OPEN_MODAL_MAINTENANCE_PRODUCT =
    'lead/OPEN_MODAL_MAINTENANCE_PRODUCT'
export const CLOSE_MODAL_MAINTENANCE_PRODUCT =
    'lead/CLOSE_MODAL_MAINTENANCE_PRODUCT'

export const OPEN_MODAL_REGISTRATION_IRREGULARITY =
    'lead/OPEN_MODAL_REGISTRATION_IRREGULARITY'
export const CLOSE_MODAL_REGISTRATION_IRREGULARITY =
    'lead/CLOSE_MODAL_REGISTRATION_IRREGULARITY'

export const OPEN_MODAL_POLLING_ERROR = 'lead/OPEN_MODAL_POLLING_ERROR'
export const CLOSE_MODAL_POLLING_ERROR = 'lead/CLOSE_MODAL_POLLING_ERROR'

export const SET_NEW_COMPANY = 'lead/SET_NEW_COMPANY'
export const SET_OLD_COMPANY = 'lead/SET_OLD_COMPANY'

export const SET_LOADING = 'lead/SET_LOADING'
export const REMOVE_LOADING = 'lead/REMOVE_LOADING'

export const CLOSE_ALL_MODAL = 'lead/CLOSE_ALL_MODAL'

export const SET_CNPJ_LEAD = 'lead/SET_CNPJ_LEAD'

export const UPDATE_LEAD = 'lead/UPDATE_LEAD'

export const SET_CNPJ_ERROR = 'lead/SET_CNPJ_ERROR'

export const REMOVE_CNPJ_ERROR = 'lead/REMOVE_CNPJ_ERROR'

export const RESET = 'lead/RESET'
